function removeElement(el: HTMLElement) {
  el.parentNode?.removeChild(el);
}

export function appendScript(url: string) {
  return new Promise((resolve, reject) => {
    const el = document.createElement('script');
    document.body.appendChild(el);
    el.addEventListener('load', () => {
      removeElement(el);
      resolve(true);
    }, false);
    el.addEventListener('error', (e) => {
      removeElement(el);
      reject(e.message);
    }, false);
    el.src = url;
  });
}

